import { Select } from 'antd'
import moment from 'moment'
import React, { useEffect, useState } from 'react'
import styled from 'styled-components'

const Wrapper = styled.div`
display:flex,
align-items:center,
`
const StyledSelect = styled(Select)`
  &.ant-select:not(.ant-select-disabled):hover .ant-select-selector {
    border-color: #1890ff;
  }
  &.ant-select-focused:not(.ant-select-disabled).ant-select:not(
      .ant-select-customize-input
    )
    .ant-select-selector {
    border-color: #1890ff;
    box-shadow: none;
  }
  &.ant-select:not(.ant-select-customize-input) .ant-select-selector {
    height: 2.6rem;
    align-items: center;
    border-radius: 0.6rem;
    width: 6rem;
  }
`

const { Option } = Select

const DatePickerDropdown = ({ label, onChange, setClear, clear, setError }) => {
  const [year, setYear] = useState(null)
  const [month, setMonth] = useState(null)
  const [day, setDay] = useState(null)

  useEffect(() => {
    setClear(false)
    setYear(null)
    setMonth(null)
    setDay(null)
    setError('')
  }, [clear])

  const handleYearChange = year => {
    setClear(false)
    setYear(year)
  }
  const handleMonthChange = month => {
    setClear(false)
    const monthIndex = moment.months().indexOf(month)
    setMonth(monthIndex)

    if (
      day &&
      day > moment(year + '-' + (monthIndex + 1), 'YYYY-M').daysInMonth()
    ) {
      setDay(null)
    }
  }
  const handleDayChange = day => {
    setClear(false)
    setDay(day)

    if (
      month !== null &&
      day > moment(year + '-' + (month + 1), 'YYYY-M').daysInMonth()
    ) {
      setDay(null)
    }
  }

  useEffect(() => {
    if (!day && !year && !month) {
      setError('')
    }
    if (!day && !month && year) {
      setError(`Please Select ${label} Day and ${label} Month`)
    }
    if (!year && !month?.toString() && day) {
      setError(`Please Select ${label} Month and ${label} Year`)
    }
    if (!year && !day && month) {
      setError(`Please Select ${label} Day and ${label} Year`)
    }
    if (!day && month && year) {
      setError(`Please Select ${label} Day`)
    }
    if (!year && month && day) {
      setError(`Please Select ${label} Year`)
    }
    if (!month?.toString() && year && day) {
      setError(`Please Select ${label} Month`)
    }
    if (day > moment(year + '-' + (month + 1), 'YYYY-M').daysInMonth()) {
      setError(
        `Invalid ${moment()
          .month(month)
          .format('MMMM')} day. Please select a valid day.`
      )
    } else if (day && year && month?.toString()) {
      setError('')
      const date = moment({ year, month, day })
      onChange(date)
    } else {
      //
    }
  }, [day, month, year])
  const StyleForSelect = {
    marginRight: label == 'Start' ? '10px' : '15px',
    height: '2.5rem',
    alignItems: 'center',
  }
  const MonthStyle = {
    marginRight: '10px',
  }
  const DayStyle = {
    marginRight: '10px',
  }
  const currentYear = new Date().getFullYear()
  const previousYears = Array.from(
    { length: 11 },
    (_, index) => currentYear - index
  )

  const dropdownStyle = {
    minWidth: 'auto',
    width: 'auto',
    top: '100%',
    marginTop: '4px',
  }
  const StyledSelectContainer = styled.div`
    position: relative;
  `

  return (
    <Wrapper>
      <StyledSelectContainer>
        <StyledSelect
          placeholder={` Day`}
          value={day}
          showSearch={true}
          allowClear={false}
          onChange={handleDayChange}
          style={StyleForSelect}
          dropdownStyle={dropdownStyle}
        >
          {Array.from(
            {
              length: moment(year + '-' + (month + 1), 'YYYY-M').daysInMonth(),
            },
            (_, index) => (
              <Option key={index + 1} value={index + 1}>
                {index + 1}
              </Option>
            )
          )}
        </StyledSelect>
      </StyledSelectContainer>
      <StyledSelect
        showSearch={true}
        allowClear={false}
        placeholder={` Month`}
        value={moment.months()[month]}
        onChange={handleMonthChange}
        style={MonthStyle}
      >
        {moment.months().map((month, index) => (
          <Option key={index + month} value={month}>
            {month}
          </Option>
        ))}
      </StyledSelect>

      <StyledSelect
        showSearch={true}
        allowClear={false}
        placeholder={` Year`}
        value={year}
        onChange={handleYearChange}
        style={DayStyle}
      >
        {previousYears.map(item => (
          <Option key={item} value={item}>
            {item}
          </Option>
        ))}
      </StyledSelect>
    </Wrapper>
  )
}
export default DatePickerDropdown
